var _effectorFileName = "/src/page-content/for-companies/ui.tsx";
import { useRouter } from 'next/router';
import { WebPageJsonLd } from 'next-seo';
import { LessonsExamples } from '@/page-content/for-companies/components/lessons-examples';
import { ForCompaniesMain } from '@/page-content/for-companies/components/main-for-companies';
import { OurOffers } from '@/page-content/for-companies/components/our-offers';
import { PlusesWorkWithUs } from '@/page-content/for-companies/components/pluses-work-with-us';
import { MainLayout } from '@/widgets/layouts/main';
import { CallToAction } from '@/widgets/layouts/main/call-to-action';
import { Partners } from '@/widgets/layouts/main/partners';
import { PageSeo } from '@/shared/lib/seo';
import { APP_TITLE } from '@/shared/lib/seo/meta';
import { HowWeWork } from './components/how-we-work';
export const ForCompaniesPage = () => {
  const router = useRouter();
  return <>
      <PageSeo title="Для компаний" description={`Организуем уроки и прокачаем английский ваших сотрудников. ${APP_TITLE} – деловой английский для работы.`} />

      <WebPageJsonLd id={router.asPath} url={`${process.env.NEXT_PUBLIC_APP_URL}${router.asPath}`} name={`${APP_TITLE} - Для компаний`} isPartOf={`${process.env.NEXT_PUBLIC_APP_URL}${router.asPath}`} description={`Организуем уроки и прокачаем английский ваших сотрудников. ${APP_TITLE} – деловой английский для работы.`} about={['английский', 'онлайн', 'для компаний', 'корпоративный английский']} />

      <ForCompaniesMain />

      <Partners />

      <PlusesWorkWithUs />

      <OurOffers />

      <HowWeWork />

      <LessonsExamples />

      <CallToAction header="Связаться с нами" description="Ответим на любые ваши вопросы в Телеграм" link={process.env.NEXT_PUBLIC_TG_SUPPORT_URL} />
    </>;
};
ForCompaniesPage.Layout = MainLayout;